module.exports = __webpack_public_path__ + "static/img/11.74639b2.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/3/1/zh/11.png
// module id = lek0
// module chunks = 0